import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { CtaSectionComponent } from '@app/widgets';
import { ANDROID_KEYSTORE_GENERATOR_FAQS } from '../../constants';
import { AndroidKeystoreGeneratorFaqSectionComponent } from '../android-keystore-generator-faq-section/android-keystore-generator-faq-section.component';
import { AndroidKeystoreGeneratorFormSectionComponent } from '../android-keystore-generator-form-section/android-keystore-generator-form-section.component';
import { AndroidKeystoreGeneratorInfoSectionComponent } from '../android-keystore-generator-info-section/android-keystore-generator-info-section.component';

@Component({
  selector: 'app-android-keystore-generator',
  imports: [
    AndroidKeystoreGeneratorFormSectionComponent,
    AndroidKeystoreGeneratorInfoSectionComponent,
    AndroidKeystoreGeneratorFaqSectionComponent,
    CtaSectionComponent,
  ],
  templateUrl: './android-keystore-generator.component.html',
  styleUrl: './android-keystore-generator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AndroidKeystoreGeneratorComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setTitle('Android Keystore Generator');
    this.metaService.setDescription(
      'Generate an Android keystore (.p12) for signing your app directly in your browser. No data is sent to any server.',
    );
    this.metaService.setKeywords([
      'Android keystore generator',
      'generate Android keystore online',
      'PKCS12 keystore',
      'Android app signing',
      'keystore generator tool',
      'Android signing certificate',
      'create keystore file',
      'Capacitor Android signing',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Android Keystore Generator',
        'Generate an Android keystore (.p12) for signing your app directly in your browser.',
        'https://cloud.capawesome.io/tools/android-keystore-generator/',
      ),
      JsonLdService.buildFaqSchema(ANDROID_KEYSTORE_GENERATOR_FAQS),
      JsonLdService.buildHowToSchema(
        'How to Generate an Android Keystore',
        'Generate a PKCS#12 keystore for signing your Android app directly in your browser.',
        [
          {
            name: 'Fill in your details',
            text: 'Enter your name, email, password, key alias, and optional organization details.',
          },
          {
            name: 'Generate your keystore',
            text: 'Click "Generate Keystore" to create your PKCS#12 keystore entirely in your browser.',
          },
          {
            name: 'Use it for app signing',
            text: 'Upload the keystore to Capawesome Cloud or your CI/CD pipeline to sign your Android builds.',
          },
        ],
      ),
    ]);
  }
}
